// extracted by mini-css-extract-plugin
export var bold = "_yv-0";